import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";

// const baseURL = "http://localhost:15301";
const baseURL = "https://lkmtraining.nomination.accenture.com/LKMtrainingNomination-apis";

export const adminUserSlice = createSlice({
  name: "Nominationlist",
  initialState: {
    error: false,
    adminUsers: [],
    isUserExists: false,
  },
  reducers: {
    setAdminUsers: (state, { payload }) => {
      state.error = false;
      state.adminUsers = payload;
    },
    setError: (state) => {
      state.error = true;
    },
    setIsUserExists: (state, payload) => {
      state.error = false;
      state.isUserExists = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAdminUsers, setError, setIsUserExists } =
  adminUserSlice.actions;

export default adminUserSlice.reducer;

export function addAdminUser(username, selectedroles) {
  const properties = { username, selectedroles };
  return (dispatch) => {
    Axios.post(
      `${baseURL}/addUser`,
      { properties },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setIsUserExists(res.data.message));
        console.log("res from getnomination list based on skills", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}
export const fetchAdminUser = () => {
  return (dispatch) => {
    Axios.get(`${baseURL}/adminUser`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        dispatch(setAdminUsers(res.data));
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
};
